import { IS_TEST, PROD_MODE } from '@reverbdotcom/env';

export function debug(msg: string) {
  if (!PROD_MODE && !IS_TEST) {
    console.warn(msg);
  }
}
